module.exports = __webpack_public_path__ + "img/工作标准.9e0327cd.svg";